/** @jsxImportSource @emotion/react */
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'
import React, { useContext, useEffect, useRef, useState } from 'react'

import req from '@sportninja/common/api/request'
import {
  getHockeySport,
  getSoccerSport,
} from '@sportninja/common/selectors/types'
import { connect } from 'react-redux'
import GeneratePluginModal from 'src/components/GeneralPluginModal'
import { NewModal } from 'src/components/NewModal'
import ScheduleModal from 'src/components/ScheduleModal'
import { ScheduleReprocessingContext } from 'src/components/ScheduleReprocessingContext'
import Page from '../../components/Page'
import ReprocessingSettingsOverlay from '../Schedule/ReprocessingSettingsOverlay'
import ScheduleListTable from './ScheduleListTable'

const Schedules = ({ hockeySport, soccerSport }) => {
  const [scheduleCount, setScheduleCount] = useState('')
  const [scheduleInitialState, setScheduleInitialState] = useState(null)
  const [scheduleInitialStateId, setScheduleInitialStateId] = useState(null)
  const [syncSalesforce, setSyncSalesforce] = useState(false)
  const [onTriggerRefresh, setOnTriggerRefresh] = useState(() => {})
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)
  const generatePluginTagModalRef = useRef(null)
  const [selectedSchedule, setSelectedSchedule] = useState(null)
  const onClickWebPluginOnScheduleList = (schedule) => {
    setSelectedSchedule(schedule)
    generatePluginTagModalRef?.current?.openModal()
  }
  const { listeners = {}, addPending } = useContext(ScheduleReprocessingContext)
  const scheduleReprocessingListener = listeners[scheduleInitialStateId]
  const [dismissed, setDismissed] = useState(false)

  const [isDaysmartConnectedAtOrgLevel, setIsDaysmartConnectedAtOrgLevel] =
    useState(false)

  const pages = [
    {
      to: `${ROUTES.SCHEDULES.ROOT}/my`,
      text: `${t('common:competition_plural', { count: 2 })} ${
        scheduleCount ? `(${scheduleCount})` : ''
      }`,
      component: (
        <ScheduleListTable
          key='schedules'
          slug='/users/me2/schedules'
          setCount={setScheduleCount}
          onEditSchedule={() => {
            setIsScheduleModalOpen(true)
          }}
          setInitialState={setScheduleInitialState}
          setOnTriggerRefresh={setOnTriggerRefresh}
          onClickWebPluginOnScheduleList={onClickWebPluginOnScheduleList}
          setSyncSalesforce={setSyncSalesforce}
          setScheduleInitialStateId={setScheduleInitialStateId}
          alwaysListArchived={false}
          initialMembershipType='both'
          shouldShowUsersMeFilters={true}
          queryRecursive={true}
          displayOrganizationColumn={true}
          showTotalCount={true}
        />
      ),
    },
  ]

  const BASE_ROUTE = `${ROUTES.SCHEDULES.ROOT}`

  // fetch organization
  useEffect(() => {
    const fetchOrganization = async () => {
      const { data } = await req(
        `/organizations/${scheduleInitialState?.organization_id}`
      )
      setIsDaysmartConnectedAtOrgLevel(
        data?.integrations?.daysmart?.is_connected
      )
    }
    if (scheduleInitialState?.organization_id) {
      fetchOrganization()
    }
  }, [scheduleInitialState])

  return (
    <>
      <Page
        displayMobileActions={false}
        baseRoute={BASE_ROUTE}
        pages={pages}
        baseTitle={t('common:competition_plural', { count: 2 })}
        title={t('util:capitalize', {
          text: t('common:competition_plural', { count: 2 }),
        })}
        isOrgsPage={true}
        hideBreadcrumbs={true}
      />
      <ScheduleModal
        isFormOpen={isScheduleModalOpen}
        setIsFormOpen={setIsScheduleModalOpen}
        initialState={scheduleInitialState || null}
        onCancel={() => {
          setScheduleInitialState(null)
          setIsScheduleModalOpen(false)
        }}
        triggerRefresh={() => {
          onTriggerRefresh()
        }}
        displayCanlanForm={syncSalesforce}
        addPending={addPending}
        isDaysmartConnectedAtOrgLevel={isDaysmartConnectedAtOrgLevel}
        sportId={scheduleInitialState?.sport_id}
      />
      <NewModal
        ref={generatePluginTagModalRef}
        shouldCloseOnOverlayClick={false}
      >
        <GeneratePluginModal
          onPressClose={() => {
            generatePluginTagModalRef?.current?.closeModal()
            setSelectedSchedule(null)
          }}
          scheduleId={selectedSchedule?.id}
          isOrganization={!selectedSchedule}
        />
      </NewModal>
      <ReprocessingSettingsOverlay
        scheduleReprocessingListener={scheduleReprocessingListener}
        setOutsideDismissed={setDismissed}
        dismissed={dismissed}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    hockeySportId: getHockeySport(state)?.id,
    soccerSportId: getSoccerSport(state)?.id,
    hockeySport: getHockeySport(state),
    soccerSport: getSoccerSport(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedules)
